import { useTranslation } from "react-i18next";

export default function IntegratedAuthFailed() {
  const { t } = useTranslation();

  return (
    <div className="flex h-screen bg-background-default">
      <div className="relative flex w-full flex-col items-center justify-center px-6 lg:w-2/5">
        <div className="w-full max-w-[22rem]">
          <h1 className="text-3xl font-semibold text-font-active">
            {t("IntegratedAuth.failedTitle")}
          </h1>
          <p className="mt-2 text-sm text-font-subtle">
            {t("IntegratedAuth.failedMessage")}
          </p>
        </div>
      </div>
    </div>
  );
}
